import { useAppSelector } from '@store';
import { Control } from 'react-hook-form';
import { CorporateApplicationStepThreeTypes } from './types';
import MonthlyVolumes from '../common/monthly-volumes';
import {
  CorporateFormValues,
  FormValues,
} from '../../../hoc/new-application/types';

import commonStyles from '../common/styles.module.css';
import Products from '../common/products';

const NewApplicationCorporateInfoStepThree = ({
  control,
  status,
  isEditable,
  errors,
  clearErrors,
  infoDictionariesIsLoading,
}: CorporateApplicationStepThreeTypes) => {
  const {
    monthlyTurnoverCorporate: monthlyTurnover,
    numberOfIncomingTransactionsCorporate: numberOfIncomingTransactions,
    numberOfOutgoingTransactionsCorporate: numberOfOutgoingTransactions,
    valueOfIncomingTransactionsCorporate: valueOfIncomingTransactions,
    valueOfOutgoingTransactionsCorporate: valueOfOutgoingTransactions,
    maxValueOfIncomingPaymentCorporate: maxValueOfIncomingPayment,
    maxValueOfOutgoingPaymentCorporate: maxValueOfOutgoingPayment,
    productsCorporate,
    baseCurrency,
  } = useAppSelector((state) => state.customersDictionaries);

  return (
    <div className={commonStyles.stepBlockWrapper} style={{ zIndex: 19 }}>
      <div className={commonStyles.stepBlockContent}>
        <MonthlyVolumes
          baseCurrency={baseCurrency}
          control={control as Control<CorporateFormValues | FormValues>}
          clearErrors={clearErrors}
          monthlyTurnover={monthlyTurnover}
          errors={errors}
          status={status}
          isEditable={isEditable}
          numberOfIncomingTransactions={numberOfIncomingTransactions}
          numberOfOutgoingTransactions={numberOfOutgoingTransactions}
          valueOfIncomingTransactions={valueOfIncomingTransactions}
          valueOfOutgoingTransactions={valueOfOutgoingTransactions}
          maxValueOfIncomingPayment={maxValueOfIncomingPayment}
          maxValueOfOutgoingPayment={maxValueOfOutgoingPayment}
          infoDictionariesIsLoading={infoDictionariesIsLoading}
        />
        <Products
          control={control as Control<CorporateFormValues | FormValues>}
          products={productsCorporate}
          clearErrors={clearErrors}
          errors={errors}
          status={status}
          isEditable={isEditable}
          infoDictionariesIsLoading={infoDictionariesIsLoading}
        />
      </div>
    </div>
  );
};

export default NewApplicationCorporateInfoStepThree;
